// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadedFile-module_wrapper__K9_lX","fileName":"UploadedFile-module_fileName__ZwjOY"};